import { Options } from 'html-to-image/lib/types'
import { Ref } from 'vue'
import { IDefaultSeries } from 'xangle-charts'

import { downloadCSV, downloadPng } from '~/utils/download.util'

export const useDownloadChart = (filename: Ref<string>) => {
  const formatChartCSV = (dataList: Array<IDefaultSeries>) => {
    const map = new Map<string, Array<(string | number | Record<string, string | number>)>>()
    const dateList = dataList[0].data.map(data => data.day)
    map.set('Date', dateList)
    dataList.forEach(data => {
      const valueList = data.data.map(data => data.value)
      map.set(data.name, valueList)
    })

    const csvHeader = Array.from(map.keys()).join(',') + '\n'

    const values = Array.from(map.values())
    const valuesLength = values[0].length
    const csvBody = Array.from({ length: valuesLength }, (_, i) =>
      values.map(arr => arr[i]).join(',')
    ).join('\n')

    return csvHeader + csvBody
  }

  const downloadChartToCSV = (chartList: Ref<Array<IDefaultSeries>>) => {
    const formattedData = formatChartCSV(chartList.value)
    downloadCSV(formattedData, filename)
  }

  const downloadChartToImage = (chartRef: Ref<HTMLElement>, imageOptions?: Partial<Options>) => {
    downloadPng(chartRef, filename, imageOptions)
  }

  return {
    downloadChartToCSV,
    downloadChartToImage
  }
}